import { getAuthHeader, WORKFLOW } from '@src/workflows/vs-standard-form/vs-standard-form.constant';
import { fetchApi } from '@src/workflows/vs-standard-form/helpers/form.helper';
import { getDataFromPropString } from '@utils/utils';
import dayjs from 'dayjs';


// Step 1: pre-validate promotion on login
export async function preValidateAuthFlow(token: string, authType: string, baseUrl: string, xDataCenter: string, body: any) {
  const url = baseUrl + '/mepa-api/app/v1/authed/submission/prevalidate';
  return authFetchApi(url, token, authType, xDataCenter, body, false);
}

// Step 2: call authentication api to retrieve gmap attributes
export async function getUserInfoFromGmap(rootUrl: string) {
  const url: string = rootUrl + '/gateway/api/user-mgmt/user/find';
  const header = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-COOKIE-AUTH': true,
      'X-SITE-ID': window.location.hostname,
    },
  };
  return fetchApi(url, header);
}

// Step 3: display gmap attributes on form
export const mapGmapValueToFormFields = (gmapData, fields) => {
  const fieldObjs = getDataFromPropString(fields);
  fieldObjs.forEach(fieldObj => {
    if (fieldObj?.gmapRef?.length > 0) {

      if (fieldObj.gmapRef === 'dob') {
        fieldObj.value = convertGMAPDateToFormDate(gmapData[fieldObj.gmapRef]);
      } else {
        fieldObj.value = gmapData[fieldObj.gmapRef];
      }
    }
  });
  return JSON.stringify(fieldObjs);
};

// START GENAI@CHATGPT4
function convertGMAPDateToFormDate(input: string): string {
  if (!input?.length) {
    return input;
  }

  const formattedDate = dayjs(input)?.format('DD-MM-YYYY');

  if (formattedDate.includes('Invalid date')) {
    return input;
  }

  return formattedDate;
}
// END GENAI@CHATGPT4

export async function authFetchApi(url, token, authType, xDataCenter, body, isFile) {
  const header = getAuthHeader(xDataCenter, body, token, isFile, authType);
  return fetchApi(url, header);
}

export const setAuthPath = (isAuth: boolean, workflow: string, locale: string, returnUrl: string) => {
  if (isAuthWorkflow(workflow) || isAuth) {
    const gmapAcceptedLocale = processToGMAPAcceptedLocale(locale);
    return {
      loginUrl: getLoginUrl(gmapAcceptedLocale, returnUrl),
      signUpUrl: getSignUpUrl(gmapAcceptedLocale, returnUrl),
      addCardUrl: getAddCardUrl(gmapAcceptedLocale, returnUrl),
    };
  }
  return null;
};

// START GENAI@CHATGPT4

export const getUrlTokenIfAny = () => {
  let params = new URLSearchParams(window.location.search);
  if (params.get('token')?.length > 0) {
    return params.get('token');
  }
  return null;
};

export const getReturnUrl = () => {
  if (!window?.location?.href) {
    return null;
  }

  const url: string = window?.location?.href?.split('?')[0];
  const paths: string[] = ['/mepa/', '/campaign/'];

  for (const path of paths) {
    if (url.includes(path)) {
      return url.substring(url.indexOf(path));
    }
  }

  return null;
};
// END GENAI@CHATGPT4

export const isAuthWorkflow = (workflow: string) => {
  return workflow?.toLowerCase() === WORKFLOW.AUTHENTICATION;
};

export const isVCESWorkflow = (workflow: string) => {
  return workflow?.toLowerCase() === WORKFLOW.VCES;
}

/* START GENAI@GHCOPILOT */
export const isSentosaWorkflow = (workflow: string) => {
  return workflow?.toLowerCase() === WORKFLOW.SENTOSA;
}
/* END GENAI@GHCOPILOT */

/* START GENAI@GHCOPILOT */
export const isSentosaCancelWorkflow = (workflow: string) => {
  return workflow?.toLowerCase() === WORKFLOW.SENTOSA_CANCEL;
}
/* END GENAI@GHCOPILOT */

export const SENTOSA_DATA_KEY_TYPE = {
  country: 'ctyregion',
  city: 'city',
  club: 'golfclub',
};

// START GENAI@CHATGPT4
export const processLocale = (locale: string) => {
  const parts = locale.split('_');
  if (parts.length !== 2) {
    return locale;
  }

  return `${parts[0]}_${parts[1].toUpperCase()}`;
};
// END GENAI@CHATGPT4

// START GENAI@CHATGPT4
export const processToGMAPAcceptedLocale = (locale: string) => {
  const parts = locale.split('_');
  if (parts.length !== 2) {
    return locale;
  }

  return `${parts[0]}_${parts[1].toLowerCase()}`;
};
// END GENAI@CHATGPT4

export const getLoginUrl = (locale: string, returnUrl: string) => {
  return `/${locale}/account/login-form?returnurl=${encodeURIComponent(returnUrl)}`;
};

export const getSignUpUrl = (locale: string, returnUrl: string) => {
  return `/${locale}/account/registration?returnurl=${encodeURIComponent(returnUrl)}`;
};

export const getAddCardUrl = (locale: string, returnUrl: string) => {
  return `/${locale}/account/edit-pan?returnurl=${encodeURIComponent(returnUrl)}`;
};
